import type { HTMLAttributes } from "react"
import { useTranslation } from "react-i18next"
import { Input, Select } from "@/shared/components"
import { Search } from "@/shared/components/ui/icons"
import { tEnergyAudit } from "@/shared/config/i18n"
import type { SetState } from "@/shared/types"
import { cn } from "@/shared/utils"

interface IProps extends HTMLAttributes<HTMLDivElement> {
  onFilter: SetState<{
    search?: string
    status?: string
  }>
  filters: {
    search?: string
    status?: string
  }
}

const Header = ({ filters, onFilter, ...props }: IProps) => {
  const { t } = useTranslation("common")
  const auditorNewEnergyAuditStatusOptions = [
    { value: "new", label: tEnergyAudit("new") },
    { value: "portfolio_shared", label: tEnergyAudit("status_energy_audit.portfolio_shared") },
    { value: "pending", label: tEnergyAudit("status_energy_audit.pending") },
    // { value: "accepted", label: tEnergyAudit("status_energy_audit.accepted") },
    { value: "rejected", label: tEnergyAudit("status_energy_audit.rejected") },
    { value: "cancelled", label: tEnergyAudit("status_energy_audit.contract_cancelled") }
  ]
  return (
    <div {...props} className={cn("header_wrapper !mt-0", props.className)}>
      <p className="header_wrapper-title">{tEnergyAudit("energy_audit")}</p>
      <div className="header_wrapper-right">
        <Input
          placeholder={t("name")}
          debounceDelay={500}
          onChange={e => onFilter({ ...filters, search: e.target?.value })}
          endIcon={<Search size={15} className="text-DarkGray" />}
        />
        <Select
          placeholder={tEnergyAudit("conclusion_status")}
          value={filters.status ? auditorNewEnergyAuditStatusOptions.find(option => option.value === filters?.status) : undefined}
          options={auditorNewEnergyAuditStatusOptions}
          onSelect={value => onFilter({ ...filters, status: value?.value ?? undefined })}
        />
      </div>
    </div>
  )
}

export default Header
